import CandidateLayout from "@/layouts/CandidateLayout";

const CandidateView = () => {
  return <CandidateLayout>CandidateView</CandidateLayout>;
};

export default CandidateView;
